//#region src/redux/i18n/thunk-types.ts
var thunkTypes = {
	GET_LOCALE: `i18n/getLocale`,
	GET_COUNTRY: `i18n/getCountry`
};
//#endregion
export { thunkTypes };

//# sourceMappingURL=thunk-types.js.map